import { Component, Input, OnInit, inject } from "@angular/core";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { BookingReasonStore } from "@app/services/store/booking-reason-store";
import { BookingReason } from "@app/models/rest/booking-reason";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-booking-reason-list",
  templateUrl: "./booking-reason-list.component.html",
  styleUrls: ["./booking-reason-list.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class BookingReasonListComponent
  extends BaseDataTablePageDirective<BookingReason>
  implements OnInit
{
  bookingReasonStore: BookingReasonStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    {
      field: "description",
      text: "Description",
      flex: 3,
      editor: true
    },
    {
      field: "forceBookingReason",
      text: "Force",
      flex: 1,
      type: "check",
      editor: true
    },
    {
      field: "newBookingReason",
      text: "New",
      flex: 1,
      type: "check",
      editor: true
    },
    {
      field: "amendBookingReason",
      text: "Amend",
      flex: 1,
      type: "check",
      editor: true
    },
    {
      field: "referBookingReason",
      text: "Referral",
      flex: 1,
      type: "check",
      editor: true
    },
    {
      field: "cancelBookingReason",
      text: "Cancellation",
      flex: 1,
      type: "check",
      editor: true
    },
    {
      field: "noteValidation",
      text: "Note",
      flex: 1,
      editor: { type: "dropdown", items: ["Required", "Optional", "Hidden"] }
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const bookingReasonStore = inject(BookingReasonStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      bookingReasonStore,
      store,
      dialog,
      "BookingReason",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.bookingReasonStore = bookingReasonStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.add([
      {
        description: ""
      }
    ]);
  }
}
